import { useLayoutEffect, useRef, useState } from "react";

/** The width drawn before the box is measured (and in tests). */
const FIRST_WIDTH = 320;

/**
 * A box's width in pixels, so an SVG chart draws at its real size and its
 * text stays crisp. Put the ref on the box the chart fills.
 */
export function useWidth() {
  const box = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(FIRST_WIDTH);
  useLayoutEffect(() => {
    const el = box.current;
    if (!el) return;
    setWidth(Math.round(el.clientWidth) || FIRST_WIDTH);
    const observer = new ResizeObserver(([entry]) => {
      if (entry) setWidth(Math.round(entry.contentRect.width) || FIRST_WIDTH);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [box, width] as const;
}
